import dayjs from 'dayjs';

export const AUTOBOOK_WINDOW_MESSAGE = 'Auto Book hours can only be set for the next 2 weeks.';

/** Fourteen local calendar dates, including today; not a difference in 24-hour blocks. */
export function isWithinAutobookWindow(dateKey: string, now: Date = new Date(), timeZone?: string | null): boolean {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)
    || dayjs(dateKey).format('YYYY-MM-DD') !== dateKey) return false;
  let todayKey = dayjs(now).format('YYYY-MM-DD');
  if (timeZone) {
    try {
      const parts = new Intl.DateTimeFormat('en', {
        timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
      }).formatToParts(now);
      const part = (type: string) => parts.find(item => item.type === type)?.value;
      todayKey = `${part('year')}-${part('month')}-${part('day')}`;
    } catch {
      // Older APIs omit the account timezone; unavailable device timezone data
      // follows the same local-calendar fallback. The API remains authoritative.
    }
  }
  const today = dayjs(todayKey);
  return dateKey >= today.format('YYYY-MM-DD')
    && dateKey <= today.add(13, 'day').format('YYYY-MM-DD');
}
